<template>
	<div name = "download">
		<HNB></HNB>
		<div class="Main">
			<div class="Mainleft">
				<div class="leftbox1">
					<div class="downloadSvg"><SvgIcon svg-name="lfSign" size="37"></SvgIcon></div>
					<div class="span">乐范健康APP</div>
				</div>
				<div class="leftbox0">让按摩变得简单</div>
				<div class="leftbox2" @click="open">Android 下载</div>
				<div class="leftbox3" @click="openios">IOS 下载</div>
			</div>
			<div class="Mainright">
				<div class="Mainrightbox1"><img :src="img"/></div>
			</div>
		</div>
		<bottom :BsTitle="bsTitle"></bottom>
	</div>
</template>

<script>
	
	import HNB from '../components/HeaderNavigationBar.vue'
	import bottom from '../components/Bottom.vue'
	import SvgIcon from '../components/SvgIcon.vue'
	
	export default{
		name:'download',
		data(){
			return {
				bsTitle: ['服务支持','APP下载'],
				img:this.GLOBAL.imgHost + '/images/relationImages/iPhone-XS-Max-Portrait-Space-Gray.png',
			} 
		},
		methods:{
			open(){
				window.open('http://sj.qq.com/myapp/detail.htm?apkName=com.easepal.magicpaster')
			},
			openios(){
				window.open('https://itunes.apple.com/cn/app/le-fan-mo-li-tie/id909537333?mt=8')
			}
		},
		components:{
			HNB,
			bottom,
			SvgIcon,
		},
	}
</script>

<style>
	.Main {
		background-color: rgb(250,250,250);
		width: 100%;
		max-width: 33.75rem;
		margin: 0 auto;
		height: 28.375rem;
		display: flex;
		flex-direction: row;
	}
	
	.Main .Mainleft { 
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 50%;
		padding-top: 30%;
		justify-content: space-around;
		height: 40%;
	}
	
	.Main .Mainleft .leftbox1{
		/* width:20.3125rem; */
		height:3rem;
		font-size:1.075rem;
		font-family:Alibaba-PuHuiTi-M;
		font-weight:500;
		color:rgba(24,24,24,1);
		line-height:1.25rem;
	}
	
	.Main .Mainleft .leftbox1 .downloadSvg{
		float: left;
		background:rgba(250,250,250,1);
		position: relative;
		left: 6%;
		bottom: 3px;
		/* top: 10%; */
	}
	
	.Main .Mainleft .leftbox1 .span{
		/* float: left; */
		position: relative;
		left: -13%;
		top: 21%;
		width: 9.25rem;
	}
	
	.Main .Mainleft .leftbox0 {
		font-size: 0.75rem;
		margin-top: -1.875rem;
		margin-left: -0.625rem;
		font-family:Alibaba-PuHuiTi-R;
	}
	
	.Main .Mainleft .leftbox2 {
		height: 2.25rem;
		width: 50%;
		border: 1px solid #00C785;
		border-radius: 0.25rem;
		font-size: 0.75rem;
		text-align: center;
		line-height: 2.25rem;
		color: #00C785;
		margin-bottom: -1.05rem;
		font-family:Alibaba-PuHuiTi-R;
	}
	
	.Main .Mainleft .leftbox3 {
		height: 2.25rem;
		width: 50%;
		border: 1px solid #00C785;
		border-radius: 0.25rem;
		font-size: 0.75rem;
		text-align: center;
		line-height: 2.25rem;
		color: #00C785;
		top: 10%;
		font-family:Alibaba-PuHuiTi-R;
	}
	
	.Main .Mainright{
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 50%;
		padding-top: 20%;
		justify-content: space-around;
		height: 17.5625rem;
	}
	
	.Main .Mainright .Mainrightbox1{
		height: 17.5625rem;
		width: 8rem;
	}
	
	.Main .Mainright .Mainrightbox1 img{
		width: 99%;
		height: 95%;
	}
	
	
	
</style>
